import Connections from '../../connections';
import {
  action, observable,
} from 'mobx';
import {
  createDeglawyFatured, getDeglawyFaturedById, getDeglawyFatures, updateDeglawyFatured, updateDeglawyFaturedStatus,
} from '../../axios/deglawyFeaturesRequests';
import {
  DefaultLanguage,
} from '../../constants/languages';
import {
  getHeader,
} from '../../helperFunctions/getHeader';
import {
  DeglawyFeatured, IDeglawyFeaturedStore,
} from '../storeInterfaces/delawyFeaturedInterface';
import { RequestStatus } from 'mobx-store';

export class DeglawyFeaturedStore implements IDeglawyFeaturedStore {
  @observable delawyFeaturesList: Array<DeglawyFeatured> = [];

  @observable selectedDelawyFeatured = new DeglawyFeatured();

  @observable loading = false;

  @observable getDeglawyFeaturedRequestStatus: RequestStatus = RequestStatus.IDLE;

  @action
  public async getDelawyFeatures(languageCode: string = DefaultLanguage): Promise<void> {
    try {
      this.loading = true;
      this.getDeglawyFeaturedRequestStatus = RequestStatus.LOADING;
      const response = await Connections.wadiDeglaAxios.httpGet(getDeglawyFatures(), getHeader(languageCode));
      this.delawyFeaturesList = this.mappingResponseToDeglawyFeatures(response.data);
      this.getDeglawyFeaturedRequestStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.getDeglawyFeaturedRequestStatus = RequestStatus.FAILED;
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  @action.bound
  public async getDelawyFeaturedById(id: number, languageCode: string = DefaultLanguage): Promise<void> {
    try {
      this.loading = true;
      const response = await Connections.wadiDeglaAxios.httpGet(getDeglawyFaturedById(id), getHeader(languageCode));
      this.selectedDelawyFeatured = this.mappingResponseToDeglawyFeatured(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  @action.bound
  public async createDelawyFeatured(newDelawyFeatured: DeglawyFeatured, languageCode: string = DefaultLanguage): Promise<void> {
    try {
      const response = await Connections.wadiDeglaAxios.httpPost(createDeglawyFatured,
        {
          ...newDelawyFeatured.getFeaturedExceptIdAndIsActive(), languageCode,
        });
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  @action.bound
  public async updateDelawyFeatured(updatedDelawyFeatured: DeglawyFeatured, id: number,
    languageCode: string = DefaultLanguage): Promise<void> {
    try {
      const response = await Connections.wadiDeglaAxios.httpPut(updateDeglawyFatured(id),
        Object.assign(updatedDelawyFeatured.getFeaturedExceptIdAndIsActive(),
          {
            languageCode,
          }));
    } catch (error) {
      console.log(error);
    }
  }

  @action.bound
  public async updateDelawyFeaturedStatus(updatedDelawyFeaturedStatus: boolean, index: number): Promise<void> {
    try {
      const response = await Connections.wadiDeglaAxios.httpPut(updateDeglawyFaturedStatus(this.delawyFeaturesList[index].getId()), {
        isActive: updatedDelawyFeaturedStatus,
      });
      this.delawyFeaturesList[index].setIsActive(updatedDelawyFeaturedStatus);
      this.delawyFeaturesList = this.delawyFeaturesList.slice();
    } catch (error) {
      console.log(error);
    }
  }

  private mappingResponseToDeglawyFeatures(deglawyFeaturesResponse: any[]): DeglawyFeatured[] {
    const deglawyFeaturesList: DeglawyFeatured[] = [];
    for (const deglawyFeaturedResponse of deglawyFeaturesResponse) {
      deglawyFeaturesList.push(this.mappingResponseToDeglawyFeatured(deglawyFeaturedResponse));
    }
    return deglawyFeaturesList;
  }

  private mappingResponseToDeglawyFeatured(deglawyFeaturedResponse: any): DeglawyFeatured {
    const deglawyFeatured = new DeglawyFeatured();
    deglawyFeatured.setId(deglawyFeaturedResponse.deglawyFeaturedId);
    deglawyFeatured.setIsActive(deglawyFeaturedResponse.isActive);
    deglawyFeatured.setPoints(deglawyFeaturedResponse.points);
    deglawyFeatured.setTitle(deglawyFeaturedResponse.title);
    deglawyFeatured.setPreview(deglawyFeaturedResponse.preview);
    deglawyFeatured.setDescription(deglawyFeaturedResponse.description);
    return deglawyFeatured;
  }
}
